import api from './api';
import { handleApiError } from '../utils/apiErrors';

export const cartService = {

    /**
     * Fetch the user's cart with all items and product details.
     * Auto-creates a cart on the server if one doesn't exist yet.
     */
    getCart: async (userId) => {
        try {
            const response = await api.get(`/cart/${userId}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    /**
     * Add a product to the user's cart.
     * If the product is already in the cart, the server increments the quantity.
     */
    addItem: async (userId, productId, quantity = 1) => {
        try {
            const response = await api.post('/cart/items', {
                user_id: userId,
                product_id: productId,
                quantity,
            });
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    /**
     * Update the quantity of a specific cart item.
     */
    updateItem: async (cartItemId, quantity) => {
        try {
            const response = await api.patch(`/cart/items/${cartItemId}`, { quantity });
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    /**
     * Remove a single item from the cart.
     */
    removeItem: async (cartItemId) => {
        try {
            const response = await api.delete(`/cart/items/${cartItemId}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    /**
     * Clear all items from the user's cart.
     */
    clearCart: async (userId) => {
        try {
            const response = await api.delete(`/cart/${userId}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },
};
